module.exports = __webpack_public_path__ + "img/signup-screenshot.fd6f57fb.svg";